import { createAnimation } from '@ionic/vue';

const NO_PAGE_TRANSITION = () => createAnimation().duration(0);

/**
 * Replace the current page with `path`, with no page slide. For a swap under a
 * full-screen cover (the BF2026 celebration's navy), where the slide would show
 * through as a band sweeping across it.
 *
 * A plain `$router.replace` inherits the replaced page's push direction in Ionic's
 * router, so it runs the iOS forward slide; a direction passed in is overwritten
 * the same way. Only an animation survives, hence a zero-length one.
 *
 * `navManager` is what <ion-router-outlet> provides (inject it); without one, as
 * in a unit test, this falls back to the plain replace.
 */
export function replaceWithoutTransition(navManager, router, path) {
  if (!navManager) return router.replace(path);
  return navManager.handleNavigate(path, 'replace', 'root', NO_PAGE_TRANSITION);
}
